import React from 'react';
import Table from 'components/Grid';
import ReactMarkdown from 'react-markdown';
import { useSelector } from 'react-redux';

const PdfFees = ({ generateTableFee, getValueByKey }) => {
  const { displayUserConfig } = useSelector(({ fundData }) => fundData);

  const sectionsConfig =
    displayUserConfig?.data?.ic_report_ui_config?.sections || [];

  const allClientKeys =
    displayUserConfig?.data?.client_ui_config?.sections
      ?.flatMap((section) => section.values || [])
      ?.map((item) => item.key) || [];

  const renderMarkdown = (text) => (
    <ReactMarkdown
      components={{ p: ({ node, ...props }) => <span {...props} /> }}
    >
      {text}
    </ReactMarkdown>
  );

  const performanceSection = sectionsConfig.find(
    (section) => section.key === 'performance_expectations'
  );

  if (!performanceSection) return null;

  return (
    <>
      {performanceSection.values?.map((subSection) => {
        const tableTitle = subSection.title;
        const tableData = [];

        // Loop through each field in the subsection
        subSection.values?.forEach((field) => {
          const isExceptionKey = field.key === 'investment_term';
          if (
            !allClientKeys.includes(field.key) &&
            !isExceptionKey &&
            field.key !== 'fee'
          )
            return;

          if (field.type === 'dict' && Array.isArray(field.values)) {
            // Nested subsection (e.g., fund_level)
            const nestedTitle = field.title;
            const nestedData = field.values
              .filter((item) => allClientKeys.includes(item.key))
              .map((item) => ({
                name: item.title,
                value: renderMarkdown(getValueByKey(item.key)) || item.title,
              }));

            if (nestedData.length > 0) {
              tableData.push({
                isNested: true,
                title: nestedTitle,
                data: nestedData,
              });
            }
          } else if (field.key === 'investment_term') {
            tableData.push({
              name: field.title,
              value: renderMarkdown(
                `${getValueByKey('fund_duration')} - ${getValueByKey('extension')}`
              ),
            });
          } else if (field.key === 'fee') {
            // Merge generateTableFee into the main tableData
            if (Array.isArray(generateTableFee)) {
              tableData.push(
                ...generateTableFee.map((item) => ({
                  name: item.key,
                  value: item.value ? item.value : '',
                }))
              );
            }
          } else {
            tableData.push({
              name: field.title,
              value: field.key ? renderMarkdown(getValueByKey(field.key)) : '',
            });
          }
        });

        // Handle special case: if `carried_interest` is in this table and not already added to `generateTableFee`
        const flatRows = tableData.filter((item) => !item.isNested);
        const nestedRows = tableData.filter((item) => item.isNested);

        // Render tables
        return (
          <div key={subSection.key} className="mb-4">
            {/* Flat Table */}
            {flatRows.length > 0 && (
              <div className="dashboard-flexBox-pdf ">
                <Table
                  allowAdd={false}
                  allowExport={false}
                  data={flatRows}
                  isLoading={false}
                  customPagination={false}
                  customSorting={false}
                  ContainerClass="table-container-fund"
                  columns={[
                    { Header: tableTitle, accessor: 'name' },
                    { Header: '', accessor: 'value' },
                  ]}
                />
              </div>
            )}

            {/* Nested Tables */}
            {nestedRows.map((nested) => (
              <div className="dashboard-flexBox-pdf " key={nested.title}>
                <Table
                  allowAdd={false}
                  allowExport={false}
                  data={nested.data}
                  isLoading={false}
                  customSorting={false}
                  customPagination={false}
                  ContainerClass="table-container-fund"
                  columns={[
                    { Header: nested.title, accessor: 'name' },
                    { Header: '', accessor: 'value' },
                  ]}
                />
              </div>
            ))}
          </div>
        );
      })}
    </>
  );
};

export default PdfFees;
